
export default function ImageInput({ image }) {
  return (
    <div style={{ textAlign: "left" }}>
      { (image !== undefined && image !== null && image !== "") ?
      <img src={image || ""} style={{ width: "90%" }}/>
      : <img src="/no_image.png" style={{ width: "90%" }}/> }
    </div>
  )
}